import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntersection } from 'react-use';
const MobileModalContentUnderHeader = t0 => {
  const $ = _c(8);
  const {
    children,
    onIntersectionChange
  } = t0;
  const contentUnderHeaderRef = useRef(null);
  const [isMajorityOfContentVisible, setIsMajorityOfContentVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.6
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const intersection = useIntersection(contentUnderHeaderRef, t1);
  let t2;
  let t3;
  if ($[1] !== intersection || $[2] !== isMajorityOfContentVisible || $[3] !== onIntersectionChange) {
    t2 = () => {
      if (intersection && isMajorityOfContentVisible !== intersection.isIntersecting) {
        setIsMajorityOfContentVisible(intersection.isIntersecting);
        onIntersectionChange?.(intersection.isIntersecting);
      }
    };
    t3 = [intersection, isMajorityOfContentVisible, onIntersectionChange];
    $[1] = intersection;
    $[2] = isMajorityOfContentVisible;
    $[3] = onIntersectionChange;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== children) {
    t4 = <div ref={contentUnderHeaderRef}>{children}</div>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
MobileModalContentUnderHeader.propTypes = {
  children: PropTypes.node,
  onIntersectionChange: PropTypes.func
};
export default MobileModalContentUnderHeader;